export const productionShortcutTemplateDescriptions: Record<string, string> = {
  '4game':
    'Игровая платформа и лаунчер для установки, обновления и запуска поддерживаемых онлайн-игр.',
  '7 Days to Die':
    'Выживание с зомби, крафтом, строительством базы и волнами атак каждые семь дней.',
  'Albion Online':
    'Песочница-MMORPG с открытой экономикой, крафтом, PvP и развитием без жёстких классов.',
  'Amazing RP':
    'Ролевой GTA/SAMP-проект с городскими сценариями, профессиями и взаимодействием игроков.',
  'Among Us':
    'Социальная дедукция на космическом корабле, где команда ищет предателей среди игроков.',
  'Apex Legends':
    'Командная королевская битва с героями-легендами, способностями и динамичной стрельбой.',
  'ARC Raiders':
    'Кооперативный extraction-экшен, где рейдеры добывают ресурсы и сражаются с механизированной угрозой.',
  'Arena Breakout':
    'Тактический extraction-шутер, где игроки заходят в рейды, собирают добычу и эвакуируются.',
  'Arena Breakout: Infinite':
    'Тактический extraction-шутер для ПК с реалистичным оружием, рейдами и эвакуацией добычи.',
  'Arizona RP':
    'Ролевой проект GTA/SAMP с открытым городом, профессиями и социальным взаимодействием.',
  'ARMA 3':
    'Военный симулятор с большими картами, реалистичной пехотой, техникой и пользовательскими сценариями.',
  'Assetto Corsa':
    'Автосимулятор с реалистичной физикой, треками, модами и гоночными автомобилями.',
  'Atomic Heart':
    'Шутер от первого лица в альтернативном СССР с роботами, аномалиями и экспериментальным оружием.',
  'Baldur’s Gate 3':
    'Пошаговая RPG по Dungeons & Dragons с сильным сюжетом, выбором и тактическими боями.',
  'Battle.net':
    'Лаунчер и онлайн-сервис Blizzard для запуска игр, обновлений и общения с друзьями.',
  'Battlefield 1':
    'Военный шутер Battlefield на тему Первой мировой войны с техникой и масштабными боями.',
  'Battlefield 2042':
    'Современный военный шутер Battlefield с крупными картами, техникой и масштабными боями.',
  'Battlefield 4':
    'Современный военный шутер с командной игрой, техникой и большими разрушаемыми картами.',
  'Battlefield 6':
    'Военный шутер серии Battlefield с масштабными сражениями, техникой и разрушаемыми локациями.',
  'Battlefield V':
    'Военный шутер Battlefield о Второй мировой войне с масштабными картами и техникой.',
  'BeamNG.drive':
    'Автосимулятор с реалистичной физикой мягких тел, авариями и свободным вождением.',
  'Black Desert':
    'MMORPG с открытым миром, зрелищными боями, ремёслами и развитием персонажа.',
  BlueStacks: 'Android-эмулятор для запуска мобильных игр и приложений на ПК.',
  Blur: 'Аркадная гонка с реальными автомобилями, боевыми усилениями и динамичными заездами.',
  Bodycam:
    'Реалистичный мультиплеерный шутер с видом от нательной камеры и напряжёнными перестрелками.',
  Brawlhalla:
    'Платформенный файтинг с короткими матчами, множеством персонажей и онлайн-сражениями.',
  'Call of Duty':
    'Серия военных шутеров от первого лица с кампаниями, мультиплеером и кооперативными режимами.',
  'Call of Duty 4: Modern Warfare':
    'Классический военный шутер с современной кампанией и влиятельным мультиплеером.',
  'Call of Duty: Warzone':
    'Бесплатная королевская битва Call of Duty с крупными картами, контрактами и быстрой стрельбой.',
  'City Car Driving':
    'Автосимулятор городского вождения с правилами дорожного движения и тренировочными сценариями.',
  'Command & Conquer: Generals':
    'RTS о современном конфликте с базостроением, ресурсами и тремя асимметричными фракциями.',
  'Command & Conquer: Generals – Zero Hour':
    'Дополнение к Generals с новыми генералами, юнитами и сценариями современной RTS.',
  'Command & Conquer: Red Alert 2':
    'Классическая RTS альтернативной истории с базами, ресурсами и яркими фракциями.',
  'Content Warning':
    'Кооперативный хоррор, где игроки снимают опасные ролики ради просмотров и выживания.',
  'Counter-Strike':
    'Классический командный тактический шутер о противостоянии спецназа и террористов.',
  'Counter-Strike 1.6':
    'Классическая версия тактического шутера Counter-Strike с раундовыми боями спецназа и террористов.',
  'Counter-Strike 2':
    'Соревновательный тактический шутер, где террористы и спецназ сражаются в раундах с бомбой или заложниками.',
  'Counter-Strike: Source':
    'Версия Counter-Strike на движке Source с классическими картами и тактическими раундами.',
  Crossout:
    'Постапокалиптический онлайн-экшен, где игроки собирают боевые машины и сражаются на аренах.',
  'Cyberpunk 2077':
    'Ролевая игра в открытом мире Найт-Сити с имплантами, выборами и футуристичным экшеном.',
  'Days Gone':
    'Открытый постапокалиптический экшен о байкере, выживании и ордах фриков.',
  DayZ: 'Онлайн-выживание в постапокалиптическом мире с зомби, лутом и встречами с другими игроками.',
  'DayZ Launcher':
    'Лаунчер для поиска серверов DayZ, управления модами и подключения к сообществам.',
  'Dead by Daylight':
    'Асимметричный хоррор, где один убийца охотится на четырёх выживших.',
  Deadlock:
    'Командный геройский экшен с линиями, стрельбой и MOBA-элементами в матчах 6 на 6.',
  Deceit:
    'Мультиплеерный хоррор с социальной дедукцией, где заражённые скрываются среди игроков.',
  'Deep Rock Galactic':
    'Кооперативный шутер о космических дворфах, добыче минералов и сражениях с жуками.',
  'Delta Force':
    'Тактический военный шутер с масштабными боями, отрядной игрой и современным вооружением.',
  'Destiny 2':
    'Онлайн-шутер с элементами MMO, кооперативными рейдами, PvP и сбором экипировки.',
  Discord:
    'Платформа голосового и текстового общения, часто используемая игровыми сообществами.',
  'DOOM Eternal':
    'Быстрый шутер от первого лица о сражениях Палача Рока с ордами демонов.',
  'Dota 2':
    'Командная MOBA, где две команды героев сражаются за уничтожение вражеской базы.',
  'Drive Beyond Horizons':
    'Автомобильное приключение с поездками, исследованием дорог и выживанием в открытом мире.',
  'Dying Light':
    'Зомби-экшен в открытом мире с паркуром, крафтом и опасной ночной охотой.',
  'Dying Light 2':
    'Открытый зомби-экшен с паркуром, фракциями и решениями в заражённом городе.',
  'Elden Ring':
    'Мрачная action-RPG в открытом мире с тяжелыми боями, боссами и исследованием Междуземья.',
  Enlisted:
    'Онлайн-шутер о Второй мировой войне с управлением отрядами пехоты, техники и авиации.',
  'Epic Games Launcher':
    'Лаунчер Epic Games для покупки, установки, обновления и запуска игр.',
  'Escape from Tarkov':
    'Хардкорный extraction-шутер с рейдами, реалистичным снаряжением и высоким риском потери добычи.',
  'Euro Truck Simulator 2':
    'Симулятор дальнобойщика с перевозками грузов, развитием бизнеса и дорогами Европы.',
  FACEIT:
    'Соревновательная платформа для матчмейкинга, античита, лиг и турниров по киберспортивным играм.',
  'Fall Guys':
    'Весёлая массовая аркада с полосами препятствий, мини-играми и выбыванием участников.',
  'Fallout 4':
    'Постапокалиптическая RPG в открытом мире с исследованием Пустоши, крафтом и поселениями.',
  'Far Cry 3':
    'Открытый шутер на тропическом острове с выживанием, захватом аванпостов и Ваасом.',
  'Far Cry 5':
    'Открытый шутер в округе Хоуп, где игрок противостоит вооружённому культу.',
  'Far Cry 6':
    'Открытый шутер на острове Яра о партизанской борьбе против диктатора.',
  'FlatOut 2':
    'Аркадные гонки с разрушениями, авариями, трюками и хаотичными заездами.',
  'Forza Horizon 4':
    'Открытая гоночная игра в Великобритании с сезонами, фестивалем и множеством автомобилей.',
  'Forza Horizon 5':
    'Открытая гоночная игра с фестивалем автомобилей, исследованием Мексики и сотнями машин.',
  FragPunk:
    'Геройский тактический шутер с карточными модификаторами, меняющими правила каждого раунда.',
  'Garry’s Mod':
    'Песочница на Source Engine с физикой, модами, серверами и пользовательскими режимами.',
  'Genshin Impact':
    'Приключенческая action-RPG в открытом мире с исследованием, элементальными боями и коллекцией персонажей.',
  'Geometry Dash':
    'Ритм-платформер с точными прыжками, музыкой и сложными пользовательскими уровнями.',
  'Ghost of Tsushima Director’s Cut':
    'Самурайский экшен в открытом мире о защите Цусимы от монгольского вторжения.',
  'God of War':
    'Приключенческий экшен о Кратосе и Атреe с кинематографичной историей и боями.',
  'Grand Theft Auto V':
    'Открытый криминальный экшен в Лос-Сантосе с сюжетной кампанией и онлайн-режимом.',
  'GTA 5 RP':
    'Ролевые серверы GTA V, где игроки отыгрывают персонажей, профессии и городские сценарии.',
  'Half-Life':
    'Классический научно-фантастический шутер о Гордоне Фримене и катастрофе в Black Mesa.',
  Hearthstone:
    'Цифровая карточная игра во вселенной Warcraft с дуэлями, колодами и героями.',
  'HELLDIVERS 2':
    'Кооперативный шутер от третьего лица о миссиях элитных десантников против инопланетных угроз.',
  'Heroes of the Storm':
    'Командная MOBA от Blizzard с героями разных вселенных и картами с уникальными целями.',
  'Hitman 3':
    'Стелс-экшен об Агенте 47 с песочными уровнями и вариативными убийствами целей.',
  'Hogwarts Legacy':
    'Ролевая игра в открытом мире Хогвартса с магией, заклинаниями и исследованием школы.',
  'Honkai: Star Rail':
    'Пошаговая sci-fi RPG от HoYoverse с космическим путешествием и отрядными боями.',
  HoYoPlay:
    'Лаунчер HoYoverse для запуска и обновления Genshin Impact, Honkai и других игр.',
  'Hunt: Showdown':
    'PvPvE extraction-шутер о охотниках на монстров в мрачных болотах Луизианы.',
  ICCup:
    'Онлайн-платформа и лаунчер для матчей, рейтингов и соревновательной игры в классические стратегии.',
  inZOI:
    'Симулятор жизни с реалистичной графикой, созданием персонажей и управлением их повседневностью.',
  'It Takes Two':
    'Кооперативное приключение для двух игроков с разнообразными механиками и семейной историей.',
  'League of Legends':
    'Командная MOBA с чемпионами, ролями и матчами за разрушение Нексуса соперника.',
  'Left 4 Dead':
    'Кооперативный зомби-шутер о выживших, пробивающихся через заражённые районы.',
  'Left 4 Dead 2':
    'Кооперативный зомби-шутер, где команда выживших пробивается через орды заражённых.',
  'Lethal Company':
    'Кооперативный хоррор о сборе металлолома на заброшенных лунах под угрозой монстров.',
  'Logitech G HUB':
    'Утилита Logitech для настройки игровой периферии, профилей, подсветки и макросов.',
  'Lost Light':
    'Extraction-шутер с рейдами, добычей, торговлей и эвакуацией из опасных зон.',
  'Mafia II':
    'Криминальный экшен о мафии середины XX века с сюжетной драмой и открытым городом.',
  'Majestic RP':
    'Ролевой GTA V сервер с профессиями, организациями и социальными сценариями.',
  'Marvel Rivals':
    'Командный геройский PvP-шутер с персонажами Marvel и их суперспособностями.',
  'Metro 2033 Redux':
    'Атмосферный постапокалиптический шутер в московском метро с мутантами и выживанием.',
  'Metro Exodus':
    'Постапокалиптический шутер с путешествием по России, выживанием и атмосферной историей.',
  Minecraft:
    'Песочница про строительство, исследование и выживание в процедурном блочном мире.',
  'Need for Speed Heat':
    'Аркадные уличные гонки с дневными заездами, ночными погонями и тюнингом автомобилей.',
  'Need for Speed Payback':
    'Аркадная гоночная игра с сюжетными ограблениями, тюнингом и открытым миром Fortune Valley.',
  'Need for Speed: Most Wanted':
    'Аркадная гоночная игра с уличными заездами, полицейскими погонями и списком соперников.',
  'Once Human':
    'Мультиплеерное выживание в странном постапокалиптическом мире с базами и монстрами.',
  'osu!':
    'Ритм-игра с пользовательскими картами, высокой скоростью реакции и соревновательными таблицами рекордов.',
  'Overwatch 2':
    'Командный геройский шутер с яркими персонажами, способностями и объективными режимами.',
  Paladins:
    'Командный геройский шутер с чемпионами, колодами талантов и объективными режимами.',
  'Path of Exile':
    'Мрачная бесплатная action-RPG с глубоким деревом пассивных навыков и охотой за лутом.',
  'Path of Exile 2':
    'Мрачная action-RPG с глубокой прокачкой, добычей предметов и сложными билдами персонажей.',
  'Payday 2':
    'Кооперативный шутер о криминальных ограблениях, планировании и перестрелках с полицией.',
  PEAK: 'Кооперативная игра о восхождении, где игроки карабкаются по опасным маршрутам и помогают друг другу.',
  Phasmophobia:
    'Кооперативный хоррор о расследовании паранормальных явлений и определении типа призрака.',
  'Portal 2':
    'Головоломка от первого лица с порталами, физикой, юмором и кооперативной кампанией.',
  'PUBG Mobile':
    'Мобильная версия PUBG с королевской битвой, командными матчами и быстрыми PvP-режимами.',
  'PUBG: Battlegrounds':
    'Королевская битва, где игроки высаживаются на карту, собирают снаряжение и борются за последнее выживание.',
  'R.E.P.O.':
    'Кооперативный хоррор о выносе ценных предметов из опасных локаций с физикой и монстрами.',
  'Radmir RP':
    'Ролевой GTA-проект с серверами, профессиями, организациями и социальными сценариями.',
  Raft: 'Выживание на плоту в океане с крафтом, сбором мусора и исследованием островов.',
  'RAGE Multiplayer':
    'Мультиплеерная платформа для пользовательских GTA V серверов и ролевых проектов.',
  'Ready or Not':
    'Тактический SWAT-шутер с зачисткой помещений, заложниками и реалистичными сценариями.',
  'Red Dead Redemption 2':
    'Открытый вестерн-экшен о банде вне закона, выживании и жизни на Диком Западе.',
  'Riot Client':
    'Лаунчер Riot Games для запуска Valorant, League of Legends и других игр компании.',
  Roblox:
    'Онлайн-платформа, где игроки создают и запускают пользовательские игры разных жанров.',
  'Rocket League':
    'Аркадный спорт, где машины играют в футбол с ускорениями, прыжками и трюками.',
  'Rockstar Games Launcher':
    'Лаунчер Rockstar для установки, обновления и запуска игр студии.',
  Rust: 'Мультиплеерная песочница на выживание, где игроки добывают ресурсы, строят базы и конфликтуют за территорию.',
  'S.T.A.L.K.E.R.':
    'Серия атмосферных шутеров с выживанием, аномалиями и исследованием Зоны.',
  'SCP: Secret Laboratory':
    'Мультиплеерный хоррор по SCP, где разные роли пытаются выжить, сбежать или остановить угрозы.',
  'Sea of Thieves':
    'Пиратское приключение в открытом море с кораблями, сокровищами и совместными рейдами.',
  'Sniper: Ghost Warrior 2':
    'Тактический шутер о снайперских миссиях, скрытности и дальних выстрелах.',
  'Sons of the Forest':
    'Продолжение The Forest с выживанием, строительством и исследованием опасного острова.',
  Squad:
    'Реалистичный командный военный шутер с упором на связь, координацию и масштабные карты.',
  'STALCRAFT: X':
    'Онлайн-шутер с выживанием, аномалиями и исследованием опасной зоны в духе сталкерской фантастики.',
  'StarCraft II':
    'Фантастическая RTS с тремя расами, быстрым микроконтролем и соревновательными матчами.',
  Stray:
    'Приключение о коте в киберпанковом городе с исследованием, загадками и робо-жителями.',
  'Stumble Guys':
    'Массовая аркада с забегами по препятствиям и выбыванием игроков в коротких раундах.',
  'Tanks Blitz':
    'Быстрый танковый онлайн-экшен с короткими командными боями и развитием техники.',
  'Team Fortress 2':
    'Командный геройский шутер с классами, юмором и режимами захвата целей.',
  'TeamSpeak 3':
    'Голосовой клиент для командной связи, часто используемый в онлайн-играх и киберспорте.',
  'The Finals':
    'Командный арена-шутер с разрушаемыми аренами, денежными целями и динамичными классами.',
  'The Forest':
    'Хоррор-выживание на острове с крафтом, строительством базы и каннибалами.',
  'The Outlast Trials':
    'Кооперативный хоррор-выживание с испытаниями, скрытностью и жестокой атмосферой экспериментов.',
  'The Sims 4':
    'Симулятор жизни, где игрок управляет персонажами, домами, отношениями и повседневными историями.',
  'Tom Clancy’s Rainbow Six Siege':
    'Тактический шутер 5 на 5 с разрушаемыми картами, операторами и осадами объектов.',
  'Ubisoft Connect':
    'Лаунчер и сервис Ubisoft для библиотеки игр, обновлений, друзей и наград.',
  Valheim:
    'Кооперативное выживание в мире викингов с крафтом, боссами и строительством баз.',
  'VK Play Игровой центр':
    'Лаунчер и игровой центр VK Play для установки, обновления и запуска игр.',
  'War Thunder':
    'Многопользовательский военный экшен с танками, авиацией и флотом разных эпох.',
  'Warcraft III':
    'Классическая RTS с героями, базостроением, фракциями и сюжетными кампаниями Warcraft.',
  Warface:
    'Онлайн-шутер от первого лица с PvP-режимами, кооперативными миссиями и классами бойцов.',
  Warframe:
    'Кооперативный sci-fi action с быстрыми ниндзя-боями, сбором снаряжения и миссиями.',
  'Wargaming.net Game Center':
    'Лаунчер Wargaming для установки, обновления и запуска игр компании.',
  'World of Tanks':
    'Многопользовательский танковый экшен с командными боями на бронетехнике XX века.',
  'World of Warcraft':
    'Классическая MMORPG во вселенной Warcraft с квестами, рейдами, подземельями и фракциями.',
  'World War Z':
    'Кооперативный зомби-шутер с огромными ордами заражённых и классами персонажей.',
  'Wuthering Waves':
    'Открытая action-RPG с динамичными боями, исследованием мира и коллекцией персонажей.',
  'Zenless Zone Zero':
    'Городская action-RPG от HoYoverse с отрядными боями, аномалиями и стильной подачей.',
  Валорант:
    'Тактический командный шутер с героями, уникальными умениями и раундами на установку Spike.',
  'Казаки 3':
    'Историческая RTS с масштабными армиями, экономикой и сражениями XVII–XVIII веков.',
  Калибр:
    'Командный тактический онлайн-шутер о спецподразделениях с ролями и заданиями.',
  'Мир кораблей':
    'Командный морской онлайн-экшен с боями на кораблях разных классов.',
  'Мир танков':
    'Командный онлайн-экшен про бронетехнику с быстрыми боями на исторически вдохновлённых танках.',
  Террария:
    'Двухмерная песочница с исследованием, крафтом, строительством и сражениями с боссами.',
  Фортнайт:
    'Онлайн-экшен с королевской битвой, строительством, событиями и пользовательскими режимами.',
};
